const RupiahFormatter = (amount: number) => {
  return amount.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' });
}

export default RupiahFormatter;